module.exports = __webpack_public_path__ + "static/media/mfinansii.93c2c2d6.png";